import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from 'components/others/SpinnerBlock';
import UsersTableBody from './UsersTableBody';
import type { UsersTableProps } from './types';

const UsersTable = ({
    showSpinner,
    setShowSpinner,
    usersList,
    fetchUsers,
    setShowUserCard,
    showRole,
    showTeam,
    showAdmin,
}: UsersTableProps) => {
    const { t } = useTranslation();
    const tableMinWidth = 440
        + (showRole ? 160 : 0)
        + (showTeam ? 150 : 0)
        + (showAdmin ? 120 : 0);

    return (
        <>
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="UsersTable table-hover" style={{ minWidth: tableMinWidth }}>
                    <thead>
                        <tr className="bg-light">
                            <td className="head-username">{t('Users.theadUserName')}</td>
                            {showRole ? <td className="head-role">{t('Users.theadRole')}</td> : null}
                            {showTeam ? <td className="head-team">{t('Users.theadTeam')}</td> : null}
                            {showAdmin ? <td className="head-admin">{t('Users.theadAdmin')}</td> : null}
                            <td className="head-status">{t('Users.theadStat')}</td>
                            <td className="head-action">{t('Users.theadActions')}</td>
                        </tr>
                    </thead>

                    <UsersTableBody
                        fetchUsers={fetchUsers}
                        usersList={usersList}
                        setShowUserCard={setShowUserCard}
                        setShowSpinner={setShowSpinner}
                        showRole={showRole}
                        showTeam={showTeam}
                        showAdmin={showAdmin}
                    />
                </Table>
            </div>
        </>
    );
};

export default UsersTable;
